"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openWindow = openWindow;
var _coreSanitize = _interopRequireDefault(require("../../core-sanitize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Open Window Handler
 * - opens a new browser window to specified location or data
 *
 * @module core-bootstrap-open-window-handler
 */

/**
* Opens a new window to the URL passed in data
*
* @param {object} data payload data containing an URL
* @return {boolean} true if window was opened, false otherwise
*/
function openWindow(data) {
  // guard clause
  if (!data || !data.url && !data.blob) {
    return false;
  }
  if (data.url) {
    var windowHandle = window.open(_coreSanitize["default"].sanitizeAll(data.url), '_blank', 'noopener,noreferrer');
    if (windowHandle) {
      windowHandle.opener = null;
    }
  } else {
    openBlob(data.blob, _coreSanitize["default"].sanitizeAll(data.fileName));
  }
  return true;
}

/**
 * Opens a blob in a new window
 *
 * @param {object} blobData blob to be opened in new window
 * @param {string} fileName name of the file
 */
function openBlob(blobData, fileName) {
  var windowHandle = null;
  var blobUrl = null;
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // for IE
    window.navigator.msSaveOrOpenBlob(blobData, fileName);
  } else {
    // other browsers
    blobUrl = URL.createObjectURL(blobData);
    windowHandle = window.open(blobUrl, '_blank', 'noopener,noreferrer');
    if (windowHandle) {
      windowHandle.opener = null;
    }
  }
  if (windowHandle && blobUrl) {
    windowHandle.addEventListener('load', function () {
      URL.revokeObjectURL(blobUrl);
    });
  }
}
//# sourceMappingURL=open-window.js.map